<template>
  <el-dialog
    ref="dialog"
    :title="dialogTitle"
    :visible.sync="dVisible"
    width="350px" top="15vh"
    :append-to-body="true"
  >
    <div class="dialog-content layout-column">
      <el-tree
        :props="defaultProps"
        node-key="TreeID"
        ref="tree"
        :auto-expand-parent="true"
        :default-expanded-keys="['list_0']"
        current-node-key="list_0"
        :highlight-current="true"
        :expand-on-click-node="true"
        :load="loadTree"
        lazy
        v-if="dVisible"
      >
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <span class="tree-span">{{ node.label }}</span>
          <span class="data-count" v-if="data.DirID > 0">({{data.DataCount}})</span>
        </div>
      </el-tree>
    </div>
    <div slot="footer" class="control dialog-footer">
      <el-button @click.stop="ensure" type="primary" size="mini">确定</el-button>
      <el-button @click="hide" size="mini">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {Message} from 'element-ui';
  import {CheckLibs,Category} from '@digital-supply-chain/module'
  import {TreeService} from "@/service";

  const isEntClient = CheckLibs.isBigEngineerE() || CheckLibs.isGreatCraftsmanEnt();
  const defaultNodeObj = isEntClient ? {
    ProdFavoriteDir: [
      {DirName: '我的收藏', CategoryID: Category.ProdFavoriteDir, DirID: 0, TreeID: 'list_0', IsLeaf: false}
    ],
    EnterpriseDir: [
      {DirName: '企业供应链', CategoryID: Category.EnterpriseDirShare, DirID: 0, TreeID: 'list_-2', IsLeaf: false},
      {DirName: '授权供应链', CategoryID: Category.EnterpriseDir, DirID: -1, TreeID: 'list_-1', IsLeaf: false},
      {DirName: '我的供应链', CategoryID: Category.EnterpriseDir, DirID: 0, TreeID: 'list_0', IsLeaf: false}
    ],
    LectoFavoriteDir: [
      {DirName: '企业零配件', CategoryID: Category.LectoFavoriteDirShare, DirID: 0, TreeID: 'list_-2', IsLeaf: false},
      {DirName: '授权零配件', CategoryID: Category.LectoFavoriteDir, DirID: -1, TreeID: 'list_-1', IsLeaf: false},
      {DirName: '我的零配件', CategoryID: Category.LectoFavoriteDir, DirID: 0, TreeID: 'list_0', IsLeaf: false}
    ],
    ResourceFavoriteDir: [
      {DirName: '我的开放资源', CategoryID: Category.ResourceFavoriteDir, DirID: 0, TreeID: 'list_0', IsLeaf: false}
    ],
  } : {
    ProdFavoriteDir: [
      {DirName: '我的收藏', CategoryID: Category.ProdFavoriteDir, DirID: 0, TreeID: 'list_0', IsLeaf: false}
    ],
    EnterpriseDir: [
      {DirName: '我的供应链', CategoryID: Category.EnterpriseDir, DirID: 0, TreeID: 'list_0', IsLeaf: false}
    ],
    LectoFavoriteDir: [
      {DirName: '我的零配件', CategoryID: Category.LectoFavoriteDir, DirID: 0, TreeID: 'list_0', IsLeaf: false}
    ],
    ResourceFavoriteDir: [
      {DirName: '我的开放资源', CategoryID: Category.ResourceFavoriteDir, DirID: 0, TreeID: 'list_0', IsLeaf: false}
    ],
  };

  export default {
    name: "dir-selector",
    props: {
      compID: { default: '' },
      categoryType: {
        type: String,
        default: ""
      },
      orderBy: { default: "CreateDate asc" }
    },
    components: {},
    data() {
      return {
        dVisible: false,
        dialogTitle: "选择一个目录",

        defaultProps: {
          children: "children",
          label: "DirName",
          isLeaf: "IsLeaf"
        },
        defaultNode: defaultNodeObj[this.categoryType],
        categoryId: Category[this.categoryType],
      }
    },
    methods: {
      show() {
        this.dVisible = true;
      },
      hide() {
        this.dVisible = false;
      },
      ensure() {
        const currentNode = this.$refs.tree.getCurrentNode();
        if (currentNode.DirID === undefined) {
          Message.warning('请选择一个目录');
          return false;
        }
        if (currentNode.DirID == -1) {
          Message.warning('请选择正确的目录');
          return false;
        }
        this.$emit('ensure', currentNode);
        this.hide();
      },

      //获取树
      async loadTree(node, resolve) {
        if (node.level == 0) {
          resolve(this.defaultNode);
        }
        if(node.data && node.data.isfixed){
           return resolve(node.data.children);
        }

        if (node.level > 0 && node.data.CategoryID === Category.ProdDir) {
          let data = await TreeService.getProddirList2(this.compID, node.data.DirID, 0);
          resolve(data);
          return;
        }

        if(node.data && (node.data.DirID == -21 || node.data.DirID == -22)){
          let type = node.data.DirID == -21 ? 1 : 2;
          let data = await TreeService.getProdClasses(type);
          data.forEach(item=>{
            item.drag = false;
          })
          resolve(data);
          return ;
        }
        if (node.level > 0) {
          const query = this.orderBy ? `&orderBy=${this.orderBy}` : "";
          var data = await TreeService.get(node.data.DirID, node.data.CategoryID, node.data, query);
          resolve(data);
          if (node.data.DirID == this.currentKey) {
            this.curNode = this.$refs.tree.getNode(this.currentKey);
          }
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .dialog-content {
    height: 300px;
    border: 1px solid #ccc;
    overflow-y: auto;
    padding: 10px;
  }

  .custom-tree-node {
    width: 100%;
    user-select: none;
    line-height: 1;
    -webkit-user-select: none;
    position: relative;
    .iconfont {
      color: #c5c5c5;
      font-size: 12px;
      padding: 2px 0;
      &:hover{
        color: dodgerblue;
        background-color: #e4e4e4;
      }
    }

    .tree-span {
      color: #606672;
      padding-left: 6px;
    }

    .data-count{
      margin-right: 10px;
      color: #999;
    }
  }

  .el-dialog__wrapper {
    /deep/ .el-dialog {
      .el-dialog__header {
        padding: 8px 10px;
        background: #f7f7f7;

        .el-dialog__title {
          font-size: 14px;
        }

        .el-dialog__headerbtn {
          top: 12px;
          right: 10px;
          line-height: 16px;
        }
      }

      .el-dialog__body {
        padding: 10px 10px 0 10px;
      }

      .el-dialog__footer {
        text-align: center;
        padding-bottom: 10px;
      }
    }
  }
</style>